import React, { FunctionComponent, useState } from "react";
import { Flex } from "antd";

import BtnNbk from "../../shared/components/BtnNBK";

import "../css/style.css";
import "../../shared/css/fontStyle.css";
import { characterStyle } from "../utils/characterStyle";

interface PALProps {
  next: () => void;
}

const CATEGORIES2 = [
  {
    title: "LECTURES DEMANDÉES",
    body: "Retrouvez les lectures demandées par l’enseignant de votre enfant dans l’espace Lectures demandées de la bibliothèque Nabook",
    path: require("../../assets/characters/maestro.png"),
    style: characterStyle(255 / 385, { left: -27 }),
  },
  {
    title: "LIRE EN LIGNE",
    body: "Les lectures demandées par l’enseignant peuvent être lues en ligne sans créer de compte Nabook.",
    path: require("../../assets/characters/smurf.png"),
    style: characterStyle(1, { bottom: 20, left: -100 }),
  },
  {
    title: "NOTRE CONSEIL",
    body: "Pour une meilleure expérience, nous vous conseillons d’installer l’application mobile Nabook. Elle offre un plus grand choix de livres et un meilleur confort de lecture.\n💡 Utilisez le code élève de votre enfant pour retrouver les lectures demandées.",
    path: require("../../assets/characters/charlotte.png"),
    style: characterStyle(556 / 463, { top: -100, bottom: 40, left: -100 }),
  },
];

const CarouselRelative: FunctionComponent<PALProps> = (props: PALProps) => {
  const { next } = props;

  const [selected, setSelected] = React.useState(0);
  const [isLoading] = useState(false);

  const dots = (s: boolean) => {
    return (
      <div
        style={{
          width: 20,
          height: 20,
          background: s ? "#FECF03" : "#3E276F",
          borderRadius: 9999,
        }}
      />
    );
  };

  const nextSerie = () => {
    if (selected + 1 === CATEGORIES2.length) {
      next();
      return;
    }
    setSelected(selected + 1);
  };

  return (
    <div className="main">
      <Flex gap={12}>
        {CATEGORIES2.map((_, i) => dots(i === selected))}
      </Flex>

      <Flex
        className="wrapper"
        style={{ justifyContent: "center", alignItems: "center" }}
        gap={18}
      >
        <div
          style={{
            background: "#FECF03",
            borderRadius: 8,
            paddingBottom: 12,
            paddingRight: 12,
            // Reserve the space of a character poking above the card so it never overlaps the dots
            marginTop: `calc(12px - ${CATEGORIES2[selected].style.marginTop})`,
            maxWidth: 700,
          }}
        >
          <Flex
            style={{
              background: "#3E276F",
              borderRadius: 8,
              alignItems: "center",
              justifyContent: "center",
              maxWidth: 700,
              marginTop: -12,
              marginLeft: -12,
            }}
          >
            <img
              style={CATEGORIES2[selected].style}
              src={CATEGORIES2[selected].path}
              alt=""
            />
            <Flex vertical style={{ marginRight: 40 }}>
              <div className="serie-title" style={{ marginBottom: 8 }}>
                {CATEGORIES2[selected].title}
              </div>
              <div className="resume">{CATEGORIES2[selected].body}</div>
            </Flex>
          </Flex>
        </div>
      </Flex>

      <Flex
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
        gap={20}
      >
        <BtnNbk
          style={{ marginTop: 0 }}
          txt={
            selected === CATEGORIES2.length - 1
              ? "Accéder à la bibliothèque"
              : "Suivant"
          }
          isLoading={isLoading}
          onClick={() => {
            nextSerie();
          }}
        />
      </Flex>
    </div>
  );
};

export default CarouselRelative;
